// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2o5-Y","boxTitle":"Qualiphy_boxTitle__6g8Ik","box":"Qualiphy_box__3lKU0","toggleWrap":"Qualiphy_toggleWrap__1E7Tv"};